import { render, staticRenderFns } from "./AddConstructionManagers.vue?vue&type=template&id=05a41a5b&scoped=true&lang=pug&"
import script from "./AddConstructionManagers.vue?vue&type=script&lang=js&"
export * from "./AddConstructionManagers.vue?vue&type=script&lang=js&"
import style0 from "./AddConstructionManagers.vue?vue&type=style&index=0&id=05a41a5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a41a5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
